export default "__VITE_ASSET__CH5CB0ZE__"